module.exports = __webpack_public_path__ + "static/media/submenu-grupos.20b88aab.svg";